'use client';

import type { ReactNode } from 'react';
import { FindingEditModalWrapper } from '../../HITL/wrappers/FindingEditModalWrapper';
import type { EditModalProps } from '../../tool-config-types';

export const renderFindingEditModal = (props: EditModalProps): ReactNode => (
  <FindingEditModalWrapper
    isOpen={props.isOpen}
    onClose={props.onClose}
    onSubmit={props.onSubmit}
    toolName={props.toolName}
    args={props.args}
    extractedData={props.extractedData}
    defaultCvssVersion={props.defaultCvssVersion}
  />
);
